<ngx-datatable
	[tablefix]="datatable"
	#datatable
	class="bootstrap"
	[rows]="roles"
	[columnMode]="'flex'"
	[rowHeight]="'auto'"
	[headerHeight]="50"
	[footerHeight]="30"
	[externalPaging]="false"
	[externalSorting]="true"
	[loadingIndicator]="loading"
	[count]="roles?.length"
	[limit]="100"
	[messages]="{
          emptyMessage: 'labels.empty-roles' | translate,
          totalMessage: 'labels.total' | translate
		}">

	<ngx-datatable-column
		prop="rolename"
		[flexGrow]="2"
		[name]="'labels.name' | translate"
		[resizeable]="false">
		<ng-template
			let-value="value"
			ngx-datatable-cell-template>
			{{value}}
		</ng-template>
	</ngx-datatable-column>

	<ngx-datatable-column
		prop="description"
		[flexGrow]="9"
		[name]="'labels.description' | translate"
		[resizeable]="false">
		<ng-template
			let-value="value"
			ngx-datatable-cell-template>
			{{value}}
		</ng-template>
	</ngx-datatable-column>

	<ngx-datatable-column
		[flexGrow]="1"
		[resizeable]="false">
		<ng-template
			let-value="value"
			let-row="row"
			ngx-datatable-cell-template>
			<input
				type="checkbox"
				[checked]="hasRole(row)"
				(click)="addremoveRole($event.target.checked, row)">
		</ng-template>
	</ngx-datatable-column>

</ngx-datatable>
